/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type BlogManagerCreateArticleRequest = {
    title: string;
    title_en?: string;
    title_cn?: string;
    image_id: number;
    context: string;
    context_en?: string;
    context_cn?: string;
    post_date?: string;
    open_status: BlogManagerCreateArticleRequest.open_status;
    release_setting?: BlogManagerCreateArticleRequest.release_setting;
    tag_ids?: string;
    is_notified?: boolean;
};

export namespace BlogManagerCreateArticleRequest {

    export enum open_status {
        EDIT = 'edit',
        RELEASE = 'release',
        NO_RELEASE = 'no_release',
    }

    export enum release_setting {
        NOW = 'now',
        DATE = 'date',
    }


}

